import React, { useState, useEffect, Fragment } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { setDefaultHeader } from "utils/httpClient";
import { useDispatch, useSelector } from "react-redux";
import { jwtTokenGenrate, userLogin } from "reduxStore/action/authActions";
import strings from "translate/language";
import { emailAddressValid, handleDetailResponse, seo } from "utils/utils";
import { getPermission } from "reduxStore/action/permissionActions";
import { AdminRoleId, MIS_RoleId } from "utils/constants";
const Signin = ({ history }) => {
  const navigate = useNavigate();
  const [loginDetail, setLoginDetail] = useState({
    device_id: "abc",
    device_type: window.navigator?.platform,
    login_type: 3,
  });
  const [passwordShown, setPasswordShown] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});

  const dispatch = useDispatch();
  const loginSelector = useSelector((state) => state.login);

  useEffect(() => {
    checklogin();
  }, [loginSelector]);

  const handleEnterPressFromFirst = (event) => {
    if (event.key === "Enter") {
      const next = document.getElementById("focus_2");
      next.focus();
    }
  };
  const handleEnterPressFromSecond = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      loginAuth();
    }
  };

  const checklogin = async () => {
    if (loginSelector.response && loginSelector.authToken) {
      if (loginSelector.response.status === 200) {
        await setDefaultHeader("token", loginSelector.response.token);
        dispatch(
          getPermission({
            isAdmin:
              handleDetailResponse(loginSelector.response.data).role_id ===
                AdminRoleId ||
              handleDetailResponse(loginSelector.response.data).role_id ===
                MIS_RoleId,
            role_id: handleDetailResponse(loginSelector.response.data).role_id,
            isMIS:
              handleDetailResponse(loginSelector.response.data).role_id ===
              MIS_RoleId,
          })
        );
        navigate("/dashboard");
      }
    } else {
      if (loginSelector.response == null) {
        dispatch(jwtTokenGenrate());
      } else {
        await setDefaultHeader("token", loginSelector.response.token);
      }
    }
  };
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };

  const validation = () => {
    let isError = true;
    let errorMessage = {};
    if (loginDetail.email === undefined || loginDetail.email === "") {
      isError = false;
      errorMessage["email"] = strings.loginemail;
    } else if (!emailAddressValid(loginDetail.email)) {
      isError = false;
      errorMessage["email"] = strings.emailValidationErr;
    }
    if (loginDetail.password === undefined || loginDetail.password === "") {
      isError = false;
      errorMessage["password"] = strings.loginpassword;
    }
    setErrorMessage(errorMessage);
    return isError;
  };
  const loginAuth = async () => {
    if (validation()) {
      const data = dispatch(userLogin(loginDetail));
    }
  };
  useEffect(() => {
    seo({
      title: "Login",
      metaDescription: "Login",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <Fragment>
      <div className="page-wrapper">
        <div className="container-fluid p-0">
          {/* login page start*/}
          <div className="authentication-main">
            <div className="row">
              <div className="col-md-12">
                <div className="auth-innerright">
                  <div className="authentication-box">
                    <div className="text-center">
                      <img
                        className="login-logo"
                        src="/assets/images/JUSTOLOGO.jpg"
                        alt=""
                      />
                    </div>
                    <div className="card mt-4">
                      <div className="card-body">
                        <div className="text-center">
                          <h4>{strings.Login}</h4>
                          <h6>{strings.enterUsernameAndPass} </h6>
                        </div>
                        <form className="theme-form">
                          <div>
                            <label className="col-form-label pt-0">
                              {strings.username}
                            </label>
                            <input
                              className="form-control"
                              autoComplete="off"
                              id="focus_1"
                              type="text"
                              onChange={(e) =>
                                setLoginDetail({
                                  ...loginDetail,
                                  email: e.target.value,
                                })
                              }
                              required=""
                              onKeyDown={handleEnterPressFromFirst}
                            />
                            {errorMessage.email && (
                              <span style={{ color: "red" }}>
                                {errorMessage.email}
                              </span>
                            )}
                          </div>
                          <div>
                            <label className="col-form-label pt-2">
                              {strings.password}
                            </label>
                          </div>
                          <div className="input-group">
                            <input
                              className="form-control"
                              autoComplete="off"
                              id="focus_2"
                              type={passwordShown ? "text" : "password"}
                              required=""
                              onChange={(e) =>
                                setLoginDetail({
                                  ...loginDetail,
                                  password: e.target.value,
                                })
                              }
                              onKeyDown={handleEnterPressFromSecond}
                              style={{
                                backgroundColor: "#e8f0fe",
                                borderRight: "none",
                              }}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text"
                                style={{
                                  backgroundColor: "#e8f0fe",
                                  borderLeft: "none",
                                }}
                              >
                                <i
                                  style={{
                                    left: "370px",
                                    fontSize: "20px",
                                    top: "6px",
                                  }}
                                  className={
                                    passwordShown
                                      ? "fa fa-eye"
                                      : "fa fa-eye-slash"
                                  }
                                  onClick={togglePassword}
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </div>
                          </div>
                          {errorMessage.password && (
                            <span style={{ color: "red" }}>
                              {errorMessage.password}
                            </span>
                          )}

                          <div className="pt-3">
                            <label
                              onClick={() => navigate("/forgotpassword")}
                              className="text-primary forgot_pass"
                              style={{ fontWeight: "bold" }}
                            >
                              {strings.forgotPass}
                            </label>
                          </div>
                          <div className="form-group form-row mt-2 mb-0">
                            <button
                              onClick={() => loginAuth()}
                              className="btn btn-primary btn-block"
                              type="button"
                            >
                              {strings.login}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* login page end*/}
        </div>
      </div>
    </Fragment>
  );
};

export default Signin;
